import { render } from "./UserSiswa.vue?vue&type=template&id=24cf3037"
import script from "./UserSiswa.vue?vue&type=script&lang=js"
export * from "./UserSiswa.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__